module.exports = __webpack_public_path__ + "assets/img/get-card-bg.e861f3ca.png";